import { CombinedQualification } from '../../shared/interfaces/qualification.interface';
import { NestingQualification } from '../../shared/interfaces/quota-nesting.interface';
import { QuotaPayload } from '../../shared/interfaces/quota.interface';
import { SurveyQuotas } from './survey-quotas';

export class NestedQualificationBuilder {
  constructor(
    private readonly _qualifications: CombinedQualification[],
    private readonly _quotas: QuotaPayload[],
    private readonly _selectedIds: number[] = []
  ) {}

  public build(): NestingQualification[] {
    return this._qualifications
      .map((q) => this._each(q))
      .filter((q) => q.isVisible);
  }

  private _each(qualification: CombinedQualification): NestingQualification {
    const {
      qualification_code,
      qualification_name,
      db_qualification_code,
      isAdvanceTargetingParent = false,
      data,
      selectedAnswers,
    } = qualification;
    return {
      qualification_code,
      qualification_name,
      isAdvanceTargetingParent,
      db_qualification_code,
      data,
      selectedAnswers: selectedAnswers || [],
      isVisible: this._visible(qualification),
      isChecked: this._checked(qualification),
    };
  }

  private _visible(qualification: CombinedQualification): boolean {
    if (qualification.isAdvanceTargetingParent) {
      return false;
    }

    if (
      new SurveyQuotas(this._quotas).hasQualification(
        qualification.qualification_code
      )
    ) {
      return true;
    }

    return false;
  }

  private _checked(qualification: CombinedQualification): boolean {
    if (!this._visible(qualification)) {
      return false;
    }

    return (this._selectedIds || []).includes(
      Number(qualification.qualification_code)
    );
  }
}
